import React from "react";
import "pages/preliquidation/preliquidation.scss";
import TablePreliquidation from "./tablePreliquidation/TablePreliquidation";
import PreliquidationFilter from "./filter/PreliquidationFilterContainer";
import { PreliquidationsProps } from "./types";
import "./i18n";
import { useTranslation } from "react-i18next";
import { Button } from "@pickit/pickit-components";
import ExportButton from "component/exportButton/ExportButton";

export const Preliquidation: React.FC<PreliquidationsProps> = ({
  isExportDisabled,
  seeMore,
  preliquidations,
  getMorePreliquidations,
  anyPreliquidationSelected,
  sendToAccounting,
  approveInvoices,
  testId,
  getPreliquidationsExport,
  filters,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <div className="presettlements-title">
        <h2 className="subTitle-pending">
          <p
            data-testId={`${testId}-title`}
            className="subtitle-pendingUser-h2"
          >
            {t("presettlements:presettlementsTitle")}
          </p>
        </h2>
        <ExportButton
          disabled={isExportDisabled}
          onClick={(e) => getPreliquidationsExport(filters, e.target)}
          testId={testId}
        />
      </div>
      <PreliquidationFilter testId="preliquidation-filter" />
      <div className="button-container-preliquidation">
        <Button
          label={t("presettlements:approveInvoices")}
          testId={`${testId}-aprove-invoices-button`}
          onClick={approveInvoices}
          size="medium"
        />
        <Button
          disabled={!anyPreliquidationSelected}
          testId={`${testId}-send-to-counting-button`}
          onClick={sendToAccounting}
          label={t("presettlements:sendToAccounting")}
          size="medium"
        />
      </div>
      <TablePreliquidation
        testId="table-preliquidation"
        items={preliquidations}
        seeMore={seeMore}
        getMorePreliquidations={getMorePreliquidations}
      />
    </>
  );
};
